import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDiseasesPhyto.success: {
            return action.payload;
        }

        case constants.getDiseasesPhyto.error: {
            return initialState;
        }

        case constants.getDiseasesPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}